module.exports = __webpack_public_path__ + "static/img/music.4c3bb1ed.svg";